import React, { useEffect } from "react"
import ReactDOM from "react-dom"
import { LazyMotion, domAnimation, m } from "framer-motion"

import Backdrop from "./Backdrop"

const dropIn = {
	hidden: {
		y: "300px",
		opacity: 0,
	},
	visible: {
		y: "0",
		opacity: 1,
		transition: {
			duration: 0.5,
			type: "easeIn",
		},
	},
	exit: {
		y: "-300px",
		opacity: 0,
	},
}

const Modal = ({ modalOpen, handleClose, rootElement = "modal-root", children }) => {
	// Prevent body scroll when modal is open
	useEffect(() => {
		if (modalOpen) {
			// Store the original overflow value
			const originalOverflow = document.body.style.overflow
			// Prevent body scroll
			document.body.style.overflow = "hidden"

			// Restore original overflow when modal closes
			return () => {
				document.body.style.overflow = originalOverflow
			}
		}
	}, [modalOpen])

	if (!modalOpen) return null

	return ReactDOM.createPortal(
		<LazyMotion features={domAnimation}>
			<Backdrop onClick={handleClose} className="overflow-y-auto">
				<div className="flex items-center justify-center min-h-full p-4">
					<m.div
						onClick={e => e.stopPropagation()}
						className="w-full md:w-4/5 max-h-screen "
						variants={dropIn}
						initial="hidden"
						animate="visible"
						exit="exit">
						<div
							className="flex justify-end text-white p-18 hover:text-pictonblue cursor-pointer"
							onClick={handleClose}>
							<svg
								className="fill-current"
								width="18"
								height="18"
								xmlns="http://www.w3.org/2000/svg">
								<path d="M10.429 9L18 1.429 16.571 0 9 7.571 1.429 0 0 1.429 7.571 9 0 16.571 1.429 18 9 10.429 16.571 18 18 16.571z" />
							</svg>
						</div>
						<div className="pb-[54px]">{children}</div>
					</m.div>
				</div>
			</Backdrop>
		</LazyMotion>,
		document.getElementById(rootElement),
	)
}

export default Modal
